import React from 'react';
import { PropTypes } from 'prop-types';
import { isEmpty, get } from 'lodash';
import formatDate from 'common/utils/Dates/formatDate';
import BaseTimelineEvent from 'common/utils/Workqueue/BaseTimelineEvent';

const ServiceAuthorizationAssignmentEvent = ({ timelineEvent }) => {
  const additionalData = get(timelineEvent, 'additional_data');

  const employeeName = get(additionalData, 'employee_name');
  const assignedTo = get(additionalData, 'assigned_to', '');
  const assignedFrom = get(additionalData, 'assigned_from', '');

  const icon = 'IconUserCircle';
  let message;
  if (!isEmpty(assignedFrom) && !isEmpty(assignedTo)) {
    message = `Reassigned to ${assignedTo} by ${employeeName}`;
  } else if (!isEmpty(assignedTo)) {
    message = `Assigned to ${assignedTo} by ${employeeName}`;
  } else if (isEmpty(assignedTo)) {
    message = `Unassigned by ${employeeName}`;
  }
  const date = formatDate(timelineEvent.timestamp);

  const formattedTimelineEvent = {
    icon,
    message,
    date,
  };

  return (
    <BaseTimelineEvent {...formattedTimelineEvent} />
  );
};

ServiceAuthorizationAssignmentEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default ServiceAuthorizationAssignmentEvent;
